import { CSM_WIDGET_POST_MESSAGE_NAMESPACE } from './consts';
import type { PostMessage } from './types';

/**
 * Shape of postmessage data including namespace to identify events as ours
 */
type NamespacedPostMessage = PostMessage & {
	namespace: typeof CSM_WIDGET_POST_MESSAGE_NAMESPACE;
};

export const isCSMWidgetMessage = (data: unknown): data is NamespacedPostMessage => {
	return Boolean(
		typeof data === 'object' &&
		data &&
		'type' in data &&
		typeof data.type === 'string' &&
		'namespace' in data &&
		data.namespace === CSM_WIDGET_POST_MESSAGE_NAMESPACE,
	);
};
